<template>
  <div class="box">
    <ApexChart
      width="99%"
      height="160"
      type="area"
      :options="chartOptions"
      :series="chartSeries"
    />
    <BLoading
      :active.sync="loading"
      :is-full-page="false"
    />
  </div>
</template>

<script>
import moment from 'moment';
import merge from 'lodash/merge';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapGetters, mapActions } = createNamespacedHelpers('statistics');

const genChartOptions = (text, labels) => ({
  chart: {
    id: 'DashboardStatisticsSalesDay',
    height: '250px',
    type: 'area',
    sparkline: { enabled: false },
    toolbar: { show: false },
  },
  toolbar: { show: false },
  stroke: { curve: 'straight' },
  fill: { opposite: 1 },
  yaxis: {
    min: 0,
    forceNiceScale: true,
    labels: {
      show: true,
      align: 'left',
      style: {
        fontSize: '8px',
      },
    },
  },
  xaxis: {
    type: 'dateTime',
    labels: {
      show: false,
      align: 'left',
      style: {
        fontSize: '8px',
      },
      rotate: -90,
    },
    tooltip: {
      enabled: false,
    },
  },
  axisTicks: { show: false },
  colors: ['#0BA23B', '#306A9B'],
  title: {
    text,
    offsetX: 30,
    style: { fontSize: '24px', cssClass: 'apexcharts-yaxis-title' },
  },
  subtitle: {
    text: 'Ventas en el día',
    offsetX: 30,
    style: { fontSize: '14px', cssClass: 'apexcharts-yaxis-title' },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: false,
  },
  labels,
});

export default {
  name: 'DashboardStatisticsSalesDay',
  data() { return { loading: false }; },
  computed: merge(
    mapState({ sales: ({ salesDay }) => salesDay }),
    mapGetters([
      'sumSalesDayTotalCurrency',
      'salesDayLabels',
      'salesDaySeries',
      'salesDayTotalCurrencyNonFiscal',
      'salesDayLabelsNonFiscal',
      'salesDaySeriesNonFiscal',
    ]),
    {
      chartOptions() {
        if (this.salesDayLabels.length > 1) {
          return genChartOptions(this.sumSalesDayTotalCurrency, this.salesDayLabels);
        }

        const date = moment({ h: 0, m: 0 }).subtract(1, 'day');
        const labels = [date.format('YYYY-MM-DD:HH:mm:ss'), ...this.salesDayLabels];

        return genChartOptions(this.sumSalesDayTotalCurrency, labels);
      },
      chartSeries() {
        if (this.salesDayLabels.length > 1) {
          return [
            { name: 'Fiscal', data: this.salesDaySeries },
            { name: 'No Fiscal', data: this.salesDaySeriesNonFiscal },
          ];
        }

        return [
          { name: 'Fiscal', data: [0, ...this.salesDaySeries] },
          { name: 'No Fiscal', data: [0, ...this.salesDaySeriesNonFiscal] },
        ];
      },
    },
  ),
  async beforeMount() {
    this.loading = true;

    const now = new Date();

    await this.getSales({
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: now.getDate(),
    });

    this.loading = false;
  },
  methods: merge(mapActions(['getSales'])),
};
</script>

<style scoped>
</style>
